import { exact } from "prop-types";

export const PollingIntervals = {
    aggressive: process.env.NODE_ENV === 'production' ? 7000 : 5000,
    short: process.env.NODE_ENV === 'production' ? 20000 : 10000,
    medium: process.env.NODE_ENV === 'production' ? 45000 : 20000,
    long: process.env.NODE_ENV === 'production' ? 60000 : 40000,
    occasional: process.env.NODE_ENV === 'production' ? 120000 : 60000
};

export const yaxis_double = [
    {
        name: "A0",
        gridLineWidth: 1,
        min: 0,
        labels: {
            format: "{text}",
        },
        title: {
            text: "",
            style: {
                color: "#425B76",
            },
        },
    },
    {
        name: "A1",
        opposite: true,
        gridLineWidth: 0,
        title: {
            text: "",
            style: {
                color: "##425B76",
            },
        },
        labels: {
            step: 1,
            format: "{value}%",
            style: {
                color: "##425B76",
            },
        },
        min: 0,
        max: 100,
    },
];

export const yaxis_count = [
    {
        name: "A0",
        gridLineWidth: 1,
        min: 0,
        labels: {
            format: "{text}",
        },
        title: {
            text: "",
            style: {
                color: "#425B76",
            },
        },
    }
];

export const yaxis_percentage = [
    {
        name: "A1",
        gridLineWidth: 1,
        title: {
            text: "",
            style: {
                color: "##425B76",
            },
        },
        labels: {
            //step: 1,
            format: "{value}%",
            style: {
                color: "##425B76",
            },
        },
        min: 0,
        max: 100,
    },
];

export const jibeTips = [
    'The definition of Jibe (verb) is, “to be in accord : AGREE”',
    'When predicting, just think about how the customer would respond to the survey.',
    'Maintain high prediction accuracy and high compliance to make progress on your achievement bar.',
    'Compliance % = # of predictions received / # of customer interactions',
    'Jibe % = # of accurate survey predictions / # of customer responses received',
    'To review how your predictions have compared to customer responses, click ‘View Interactions’ at the top of your dashboard ',
    'Over 90% of customers don’t respond to their surveys, that makes your predictions critical to understanding accurate customer satisfaction for every interaction.',
    'Zacoustic enables you to be the voice of the customer!',
    'The definition of Proxy (noun) is, “the authority or power to act for another”',
    'When you are Jibing with customers, that means your predictions consistently match their survey responses.',
    'Zacoustic allows your organization to generate valuable insights to improve customer and employee experiences.',
    'If it correctly matches the customer’s satisfaction, you will never get in trouble for making a negative survey prediction.',
    'REMEMBER: Your goal with Zacoustic is to make ACCURATE survey predictions for every interaction. Your goal IS NOT to make POSITIVE predictions for every interaction.',
    'Click on a question and view how your prediction breakdown compares to the customer responses you’ve received.',
    'When you’re viewing your prediction breakdown, you’ll see which prediction you need to predict more often.'
];

export const colors = {
    secandary200: '#49C2CB', //'#32A6AE',//ASAT Green
    fourth200: '#AE83E2',//RES Purple
    primary200: '#FF9538',//CSAT Orange
    correctGreen: '#00BBA7',
    incorrectRed: '#F2547D',
    neutralGrey: '#7B93AF',
    correctGreenPrimary: '#22B14C',
    incorrectRedPrimary: '#ED1C24',
    neutralYellowPrimary: '#FFF200',

}

export const roleType = {
    agent: 1,
    supervisor: 2,
    manager: 3,
    admin: 4,
    superAdmin: 5
}

export const filterType = {
    team: 'Team',
    channel: 'Channel',
    reasonForContact: 'RFC',
    agent: 'Agent',
}

export const timePeriodicityOptions = [
    { id: 1, value: 'Daily', text: '24 h', isDefaultSelected: true },
    { id: 2, value: 'Weekly', text: '1 week' },
    { id: 3, value: 'Monthly', text: '30 days' }]

export const agentsFilters = [{ filterName: "All" }, { filterName: "Jibed" }, { filterName: "Not Jibed" }];
export const teamsFilters = [{ filterName: "All" }, { filterName: "Jibed" }, { filterName: "Not Jibed" }];
export const jibedTeamThreshold = 75;
export const jibedAgentThreshold = 75;
export const jibeMinRequredSurveyCount = 10;

export const columnsAccessors = {
    name: 'name',
    team: 'team',
    agentName: 'agentName',
    agentTeam: 'agentTeam',
    role: 'role',
    agents: 'agents',
    avgBias: 'avgBias',
    bias: 'bias',
    biasVsLastMonth: 'biasVsLastMonth',
    avgBiasVsLastMonth: 'avgBiasVsLastMonth',
    fullyJibedAgentsCount: 'fullyJibedAgentsCount',
    sessionCnt: 'sessionCnt',
    lastJibeSession: 'lastJibeSession',
    representativeSatisfaction: 'representativeSatisfaction',
    resolution: 'resolution',
    customerSatisfaction: 'customerSatisfaction',
    reasonForContact: 'reasonForContact',
    date: 'date',
    startDate: 'startDate',
    interactionExternalId: 'interactionExternalId',
    interactionExternalIdNode: 'interactionExternalIdNode',
    status: 'status',
    type: 'type',
    action: 'action',
    surveyType: 'surveyType',
    handleTime: 'handleTime',
    totalTimeSpentInSecond: 'totalTimeSpentInSecond',
    supervisor: 'supervisor'
};

export const dayMonthFormat = "MM/DD";
export const dateFormat = "MM/DD/YYYY";
export const dateTimeFormat = "MM/DD/YYYY HH:mm:ss";

export const urlParameters = {
    view: 'view',
};

export const reasonForContactQuestions = {
    ICD: {
        Id: '23',
        Name: 'Subject',
        Type: 'surveyQuestion'
    },
    Essilor: {
        Id: '17',
        Name: 'Wrap up Code',
        Type: 'surveyQuestion'
    },
    Rockstar: {
        Id: '3',
        Name: 'Issue Type',
        Type: 'surveyQuestion'
    },
    MLB: {
        Id: '9',
        Name: 'Case Type',
        Type: 'surveyQuestion'
    },
    Facebook: {
        Id: '5',
        Name: 'Reasons for Contact',
        Type: 'surveyQuestion'
    }
};

export const likertScaleAnswerValues = {
    ICD: {
        verySatisfied: 'Very Satisfied',
        somewhatSatisfied: 'Somewhat Satisfied',
        neutral: 'Neutral',
        somewhatDissatisfied: 'Somewhat Dissatisfied',
        veryDissatisfied: 'Very Dissatisfied'
    },
    MLB: {
        verySatisfied: '5 - Very Satisfied',
        somewhatSatisfied: '4 - Somewhat Satisfied',
        neutral: '3 - Neutral',
        somewhatDissatisfied: '2 - Somewhat Dissatisfied',
        veryDissatisfied: '1 - Very Dissatisfied'
    },
    Rockstar: {
        verySatisfied: '5',
        somewhatSatisfied: '4',
        neutral: '3',
        somewhatDissatisfied: '2',
        veryDissatisfied: '1'
    },
    TML: {
        verySatisfied: '5 - Very Satisfied',
        somewhatSatisfied: '4 - Somewhat Satisfied',
        neutral: '3 - Neutral',
        somewhatDissatisfied: '2 - Somewhat Dissatisfied',
        veryDissatisfied: '1 - Very Dissatisfied'
    },
    Facebook: {
        verySatisfied: ['10', '9'],
        neutral: ['8', '7'],
        veryDissatisfied: ['6', '5', '4', '3', '2', '1']
    },
};

export const clientNames = {
    ICD: 'ICD',
    Essilor: 'Essilor',
    Rockstar: 'Rockstar',
    TML: 'TML',
    Facebook: 'Facebook',
    Dtv: 'Dtv',
    Demo: 'Demo'
};

export const clientIdNumber = {
    ICD: 91,
    Essilor: 92,
    Mlb: 95,
    TML: 96,
    Rockstar: 100,
    Facebook: 101,
    Comcast: 105
};

export const metricTypeId = {
    AverageHandleTime: 1,
    NetPromoterScore: 2,
    RepresentativeSatisfaction: 3,
    Resolution: 4,
    CustomerEffortScore: 5,
    TimeToResolve: 6,
    Interactions: 7,
}

export const metricTypeName = {
    AverageHandleTime: 'AHT',
    NetPromoterScore: 'NPS',
    RepresentativeSatisfaction: 'RSAT',
    Resolution: 'Resolution',
    CustomerEffortScore: 'CES',
    TimeToResolve: 'Time To Resolve',
}

export const coachingStatus = {
    Ignored: 1,
    Open: 2,
    Coached: 3,
    CoachMe: 4
};

export const signalStatus = {
    Open: 1,
    Resolved: 2,
    Ignore: 3,
    Delete: 4
};

export const actionStatus = {
    CalibrationCoaching: 1,
    NewQAEvaluation: 2,
    NoImprovementDemonstrated: 3,
    AgentRequestedCoaching: 4,
}

export const VariluxAgentGroup = {
    100772: 'Debora Hudson',
    102345: 'Elizabeth Emanuel',
    99357: 'Penny Rogers',
    100310: 'Stephanie Delgado',
    99353: 'Stephanie Mcdonald',
    101793: 'Sarah Mcpeake'
}

export const specialAccount = {
    VariluxDecliner: 'Varilux Decliner'
}

export const likertScaleAnswerColors = {
    verySatisfied: '#007535',
    somewhatSatisfied: '#00c459',
    neutral: '#ffd64a',
    somewhatDissatisfied: '#df5d50',
    veryDissatisfied: '#853730',
    unanswered: 'grey'
};

export const resolutionAnswerColors = {
    yes: '#00C459',
    no: '#DF5D50',
    unanswered: 'grey'
};

export const NextGenMaxAgentPromoQuestionCount = 3;
export const NextGenMinNumberOfDaysSinceLastYes = 7;
export const EssilorEmailSurveyQuestionId = 423;

export const ApiResultsNumberUpperBound = 4000;
export const GetUserApiMaxNumber = 4000;
export const DictionaryCode = {
    ClosingStatement: 'ClosingStatement',
    Prev: 'Prev',
    Next: 'Next',
    Submit: 'Submit'
};

export const RockstarCustomerSurveyQuestions = {
    CustomerEffort: {
        Id: 16,
        Name: 'Customer Effort'
    },
    WrongComments: {
        Id: 17,
        Name: 'Wrong Comments'
    },
    EarnScoreComments: {
        Id: 18,
        Name: 'Earn Score Comments'
    },
    GreatComment: {
        Id: 19,
        Name: 'Great Comment'
    },
    AgentHelpfulness: {
        Id: 20,
        Name: 'Agent Helpfulness'
    },
    AboutYourExperienceComment: {
        Id: 22,
        Name: 'About Your Experience Comment'
    },
    EaseOfUse: {
        Id: 23,
        Name: 'Ease of Use'
    },
    WhatToImproveComment: {
        Id: 24,
        Name: 'What to Improve Comment'
    },
    SubmitComment: {
        Id: 25,
        Name: 'Submit Comment'
    }
};